// converts Cleave format to number ("1.234,56" to 1234.56)
export const convertCleaveFormat = (value, originalValue) => {
    if (typeof originalValue === 'string') {
        if (originalValue.includes('.') || originalValue.includes(',')) {
            return parseFloat(originalValue.replace(/\./g, '').replace(',', '.'))
        }

        // parse any other format eg. 50% to 50
        return parseFloat(originalValue)
    }

    return value
}

export const addPercentageSuffix = (value) => {
    if (!value || value === '') {
        return value
    }

    return String(value).includes('%') ? value : `${value}%`
}
